<template>
  <body>
    <aside class="Blk-1">
      <canvas id="canvas2" class="myCanvas" v-show="!colSel"></canvas>
      <div class="textIzq" v-show="(buscaPalCat != '' || busquedasSel != 0) && !colSel">
        {{"Se han encontrado " + resBusGenCat.length + " coincidencias"}}
      </div>
      <div class="textIzq" v-show="buscaPalCol != '' && colSel  && finBusGenCol">
        {{"Coincidencias encontradas:"}}
        <div class="Blk-Res" v-for="(coinc, index) in encontrados" :key="index">
          {{ coinc.Col + ': ' + coinc.Coin }}
        </div>
      </div>
    </aside>
    <aside class="Blk-2">
      <article class="Form">
        <div class="justiTel">
          <div class="searchHeader">
            <fieldset id="colOcat">
              <input type="radio" class="rad1" value="Col" v-model="select" name="colOcat" checked>
              <label for="col" class="labRad"> Colecciones</label>
              <input type="radio" class="rad1" value="Cat" v-model="select" name="colOcat" >
              <label for="cat" class="labRad"> Catastro</label>
            </fieldset>
            <fieldset id="simpOavan" class="busq" v-show="!colSel">
              <p>BÚSQUEDA</p>
              <input type="radio" class="rad2" value="Simp" v-model="select1" name="senOava" @change="borraDatos" checked>
              <label for="simp" class="labRadCat"> Simple</label>
              <input type="radio" class="rad2" value="Avan" v-model="select1" name="senOava" @change="borraDatos">
              <label for="avan" class="labRadCat"> Avanzada</label>
            </fieldset>
          </div>
          <div class="Blk-botonesTelCat">
            <button class="Btn-BusCat-Tel" @click="queBuscarTel()" :disabled="deshabilitarBuscar">Buscar</button>
            <button class="Btn-Map-Tel" v-show="!colSel" @click="mostrarMapa()">{{ verMapa? 'Ocultar' : 'Mapa'}}</button>
          </div>
        </div>
        <!-- ---------------Búsqueda simple COLECCIONES cabecera ------------------------------ -->
        <div v-show="colSel" class="colecciones">
          <div class="coleccionesSel">
            <button :class="[arrayCCGCol[0].check ? 'colSel' : 'colNoSel']" @click="selectCol(0)">Libros</button>
            <button :class="[arrayCCGCol[1].check ? 'colSel' : 'colNoSel']" @click="selectCol(1)">Publicaciones periodicas</button>
            <button :class="[arrayCCGCol[2].check ? 'colSel' : 'colNoSel']" @click="selectCol(2)">Memorias de congresos</button>
            <button :class="[arrayCCGCol[3].check ? 'colSel' : 'colNoSel']" @click="selectCol(3)">Literatura gris</button>
            <button :class="[arrayCCGCol[4].check ? 'colSel' : 'colNoSel']" @click="selectCol(4)">Hemerografías</button>
            <button :class="[arrayCCGCol[5].check ? 'colSel' : 'colNoSel']" @click="selectCol(5)">Artículos y separatas</button>
            <button :class="[arrayCCGCol[6].check ? 'colSel' : 'colNoSel']" @click="selectCol(6)">Sellos</button>
            <button :class="[arrayCCGCol[7].check ? 'colSel' : 'colNoSel']" @click="selectCol(7)">Postales</button>
            <button :class="[arrayCCGCol[8].check ? 'colSel' : 'colNoSel']" @click="selectCol(8)">Misceláneos</button>
          </div>
          <input type="text" class="buscaPalCol" placeholder="<Escribe la palabra a buscar>" v-model.trim="buscaPalCol">
          <button class="BtnBuscarCol" @click.prevent="buscaColGen()" :disabled="deshabBtnBuscarCol">Buscar</button>
        </div>
        <!-- --------------------Búsqueda simple CATASTRO ------------------------------------------- -->
        <div v-show="!colSel && simpSel" class="catastro">
          <input type="text" class="buscaPalCat" placeholder="<Escribe la palabra a buscar>"
            v-model.trim="buscaPalCat">
          <button class="BtnBuscarCat" @click="buscaCatGen()" :disabled="deshabBtnBuscarPalCat">Buscar</button>
        </div>
         <!-- -------------------Búsqueda avanzada CATASTRO ------------------------------------------ -->
        <div v-show="!simpSel && !colSel" class="busqAv1">
          <div class="F1">
            <FiltroGEN :nombre="'Altura snm'"
              @select="alturaSelect"/>
            <FiltroGEN :nombre="'Desarrollo'"
              @select="DesaSelect"/>
            <FiltroGEN :nombre="'Desnivel'"
              @select="DesniSelect"/>
              <button class="BtnBuscarCat" @click="buscaCatAva()" :disabled="deshabilitarBuscar">Buscar</button>
          </div>
        </div>
        <div class="F2">
          <div class="coinciTel" v-show="(buscaPalCat != '' || busquedasSel != 0) && !colSel">
            {{"Se han encontrado " + resBusGenCat.length + " cuevas"}}
          </div>
        </div>
        <canvas id="canvas3" class="myCanvas" v-show="!colSel && verMapa"></canvas>
        <section class="resultCat" v-show="!colSel">
          <div class="Blk-Res" v-for="(resultado, index) in resBusGenCat" :key="index">
            <p class="titular">{{resultado.abrEst + resultado.numCat}} - {{resultado.nombre}}</p>
            <p class="L1" v-html="resalta(resultado.zonaCarstica)"></p>
            <p class="L2" v-html="resalta(resultado.localizacion)"></p>
            <p class="L12">Desarrollo: {{resultado.desarrollo}} m - Desnivel: {{resultado.desnivel}} m - {{resultado.altitud}} m s.n.d.m.</p>
            <p class="L2" v-html="resalta(resultado.topo)"></p>
            <p class="L3">BSVE: {{resultado.boletin}}</p>
            <p class="L1"></p>
          </div>
        </section>
        <!-- -------------------Búsqueda simple COLECCIONES ------------------------------------ -->
        <div v-if="loading" class="loader">
        </div>
        <div v-else>
          <section class="resultCat" v-if="colSel && finBusGenCol">
            <modPresResColGen class="modulo"
              :palabra="buscaPalCol"
              :resultados="resBusGenCols"/>
          </section>
        </div>
      </article>
    </aside>
  </body>
</template>

<script> // ya está codificado incluir token en cabeceras de peticiones
import { mapState } from 'vuex' // en Computed está ...mapState(['usuarioEnSesion'])
import axios from 'axios'
import CCGCol from '@/assets/JSON/arrayCCGCol.json'
import FiltroGEN from '@/components/FiltroGEN.vue'
import modPresResColGen from '@/components/modPresResColGen.vue'
export default {
  name: 'FormBusquedas',
  components: { FiltroGEN, modPresResColGen },
  created () {
    this.URLbase = process.env.VUE_APP_ROOT_API
    this.token = this.usuarioEnSesion.tokenUser
    this.arrayCCGCol = CCGCol
  },
  data () {
    return {
      select: 'Col',
      select1: 'Simp',
      buscaPalCat: '',
      buscaPalCol: '',
      resBusGenCat: [],
      resBusAvaCat: [],
      arrayFiltro: [],
      busquedasSel: 0,
      puntos: [],
      arrayCCGCol: [],
      resBusGenCols: [],
      finBusGenCol: false,
      verMapa: false,
      loading: false
    }
  },
  methods: {
    async buscaCatGen () {
      if (this.buscaPalCat.length < 2) {
        this.alertJoa('No se permiten búsquedas de un solo caracter', 'W')
        this.buscaPalCat = ''
        return
      }
      try {
        const url = `${this.URLbase}/cuevas/getBuscaGen`
        const pal = { palabra: this.buscaPalCat }
        axios.post(url, pal, {
          headers: {
            authorization: this.token
          }
        })
          .then(result => {
            const resBus = result.data
            this.resBusGenCat = resBus.sort(function (a, b) {
              if (a.abrEst > b.abrEst) { return 1 }
              if (a.abrEst < b.abrEst) { return -1 }
              return (a.numCat - b.numCat)
            })
            this.puntos = this.resBusGenCat.map(obj => ({ lon: obj.coorLonW, lat: obj.coorLatN }))
            this.dibujarPosicion(this.puntos, this.anchoVW)
          })
          .catch(error => console.log(error))
      } catch (error) {
        alert(error)
      }
    },
    async buscaCatPar () { // No se está usando
      try {
        const url = `${this.URLbase}/cuevas/getBuscaPart`
        const pal = { palabra: this.buscaPalCat }
        axios.post(url, pal, {
          headers: {
            authorization: this.token
          }
        })
          .then(result => {
            const resBus = result.data
            this.resBusGenCat = resBus
            this.puntos = this.resBusGenCat.map(obj => ({ lon: obj.coorLonW, lat: obj.coorLatN }))
            console.log(this.puntos)
            this.dibujarPosicion(this.puntos)
          })
          .catch(error => console.log(error))
      } catch (error) {
        alert(error)
      }
    },
    async buscaCatAva () {
      try {
        const url = `${this.URLbase}/cuevas/getBuscaAvan`
        const arrayAux = this.arrayFiltro.filter(e => e !== '')
        let query = ''
        if (arrayAux.length === 1) {
          query = arrayAux.join(', ')
        } else {
          query = '{ "$and": [' + arrayAux.join(', ') + '] }'
        }
        if (query === '') { this.alertJoa('No hay criterios de búsqueda seleccionados', 'W') }
        axios.post(url, { Q: query }, {
          headers: {
            authorization: this.token
          }
        })
          .then(result => {
            const resBus = result.data
            this.resBusGenCat = resBus.sort(this.ordenarEstNum)
            this.puntos = this.resBusGenCat.map(obj => ({ lon: obj.coorLonW, lat: obj.coorLatN }))
            this.dibujarPosicion(this.puntos, this.anchoVW)
          })
          .catch(error => console.log(error))
      } catch (error) {
        alert(error)
      }
    },
    // resalta (pal) {
    //   const resaltado = pal.replaceAll(this.buscaPalCat, `<mark>${this.buscaPalCat}</mark>`)
    //   return resaltado if (e.normalize('NFD').replace(/[\u0300-\u036f]/i, '') === this.buscaPalCat.normalize('NFD').replace(/[\u0300-\u036f]/i, ''))
    // }
    selectCol (col) {
      this.arrayCCGCol[col].check ? this.arrayCCGCol[col].check = false : this.arrayCCGCol[col].check = true
    },
    async buscaColGen () {
      if (this.buscaPalCol.length < 2) {
        this.alertJoa('No se permiten búsquedas de un solo caracter', 'W')
        this.buscaPalCol = ''
        return
      }
      this.loading = true
      this.resBusGenCols = []
      // this.arrayCCGCol.forEach((e, index) => {
      //   if (e.check) {
      //     this.buscaPalCols(this.buscaPalCol, e.ruta, index)
      //   }
      // })
      // this.finBusGenCol = true
      // this.loading = false
      // Crear un array de promesas para manejar las solicitudes
      const promesas = this.arrayCCGCol.reduce((acc, e, index) => {
        if (e.check) {
          const promesa = this.buscaPalCols(this.buscaPalCol, e.ruta, index)
          if (promesa) {
            acc.push(promesa)
          }
        }
        return acc
      }, [])
      try {
        await Promise.all(promesas) // Esperar a que todas las solicitudes terminen
      } catch (error) {
        console.error('Error en la búsqueda:', error)
        this.alertJoa('Ocurrió un error en la búsqueda', 'E')
      } finally {
        this.finBusGenCol = true
        this.loading = false // Desactivar indicador de carga
      }
    },
    async buscaPalCols (a, b, c) {
      try {
        const url = `${this.URLbase}${b}`
        const P = { palabra: `${a}` }
        await axios.post(url, P, {
          headers: {
            authorization: this.token
          }
        })
          .then(result => {
            const titulo = this.arrayCCGCol[c].res
            const resBus = result.data
            const miArray = [titulo, resBus]
            this.resBusGenCols.push(miArray)
          })
          .catch(error => console.log(error))
      } catch (error) {
        alert(error)
      }
    },
    borraDatos () {
      this.resBusGenCat = []
      this.buscaPalCat = ''
      this.limpiarMapa(this.anchoVW)
    },
    resalta (frase) {
      var palB = this.buscaPalCat
      if (palB.length >= 3) {
        if (palB.includes(' ')) {
          palB = palB.split(' ')[0].replace('"', '').trim()
        }
        let fraseElem = frase.replace('-', ' - ')
        fraseElem = fraseElem.split(' ')
        const fraseEleTr = fraseElem.map(e => {
          const Orig = e.normalize('NFD').replace(/\.|"|'|-|,|[\u0300-\u036f]/gi, '')
          const Busc = palB.normalize('NFD').replace(/[\u0300-\u036f]/gi, '')
          if (Orig.toLowerCase() === Busc.toLowerCase()) { return `<mark>${e}</mark>` } else { return e }
        })
        const fraseTr = fraseEleTr.join(' ')
        return fraseTr
      }
    },
    alturaSelect (select) {
      // console.log(select)
      let a = ''
      select.masQue ? a = '"$gte": ' : a = '"$lte": '
      if (select.check && select.valorFil !== 0) {
        this.arrayFiltro[0] = '{ "altitud": { ' + a + (select.valorFil) + ' } }'
        this.busquedasSel++
      } else {
        this.arrayFiltro[0] = ''
        this.busquedasSel === 0 ? this.busquedasSel = 0 : this.busquedasSel--
      }
      // console.log(this.arrayFiltro)
    },
    DesaSelect (select) {
      let a = ''
      select.masQue ? a = '"$gte": ' : a = '"$lte": '
      if (select.check && select.valorFil !== 0) {
        this.arrayFiltro[1] = '{ "desarrollo": { ' + a + (select.valorFil) + ' } }'
        this.busquedasSel++
      } else {
        this.arrayFiltro[1] = ''
        this.busquedasSel === 0 ? this.busquedasSel = 0 : this.busquedasSel--
      }
    },
    DesniSelect (select) {
      let a = ''
      select.masQue ? a = '"$gte": ' : a = '"$lte": '
      if (select.check && select.valorFil !== 0) {
        this.arrayFiltro[2] = '{ "desnivel": { ' + a + (select.valorFil) + ' } }'
        this.busquedasSel++
      } else {
        this.arrayFiltro[2] = ''
        this.busquedasSel === 0 ? this.busquedasSel = 0 : this.busquedasSel--
      }
    },
    dibujarPosicion (puntos, canvas) {
      const A = -73.4166666667
      const B = -59.8027777778
      const C = 12.1894444444
      const D = 0.84311111111
      const myCanvas = document.getElementById(canvas)
      const ancho = myCanvas.width
      myCanvas.height = ancho * 0.8578569
      const alto = myCanvas.height
      var ctx = myCanvas.getContext('2d')
      ctx.clearRect(0, 0, ancho, alto)
      ctx.fillStyle = 'rgb(250,0,0)'

      for (let i = 0; i < puntos.length; i++) {
        const w = puntos[i].lon
        const n = puntos[i].lat
        if (!(w || n)) { continue }
        const x = Number(w.substr(0, 2)) + (Number(w.substr(4, 2))) / 60 + (Number(w.substr(8, 2))) / 3600
        const y = Number(n.substr(0, 2)) + (Number(n.substr(4, 2))) / 60 + (Number(n.substr(8, 2))) / 3600
        const xP = ((-x - A) / (B - A)) * ancho
        const yP = ((y - C) / (D - C)) * alto
        ctx.beginPath()
        ctx.arc(xP, yP, 2, 0, 2 * Math.PI)
        ctx.fill()
      }
    },
    mostrarMapa () {
      this.verMapa = !this.verMapa
    },
    limpiarMapa (canvasId) {
      const myCanvas = document.getElementById(canvasId)
      const ctx = myCanvas.getContext('2d')
      ctx.clearRect(0, 0, myCanvas.width, myCanvas.height)
    },
    ordenarEstNum (a, b) {
      if (a.abrEst < b.abrEst) {
        return -1
      }
      if (a.abrEst > b.abrEst) {
        return 1
      }
      return a.numCat - b.numCat
    },
    queBuscarTel () {
      if (this.colSel) {
        this.buscaColGen()
      } else {
        this.simpSel ? this.buscaCatGen() : this.buscaCatAva()
      }
    }
  },
  computed: {
    colSel () {
      return this.select === 'Col'
    },
    simpSel () {
      return this.select1 === 'Simp'
    },
    deshabilitarBuscar () {
      return (this.busquedasSel === 0 && !this.simpSel)
    },
    deshabBtnBuscarCol () {
      return (this.buscaPalCol === '')
    },
    deshabBtnBuscarPalCat () {
      return (this.buscaPalCat === '')
    },
    encontrados () {
      return this.resBusGenCols.map(e => { return { Col: e[0], Coin: e[1].length } })
    },
    anchoVW () {
      return window.innerWidth < 575 ? 'canvas3' : 'canvas2'
    },
    ...mapState(['usuarioEnSesion'])
  },
  watch: {
    buscaPalCol: function () {
      this.resBusGenCols = []
    },
    buscaPalCat: function () {
      this.resBusGenCat = []
    }
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.myCanvas {
  background-image: url('../assets/mapa_de_venezuela.svg');
  background-size: cover;
  margin-top: 40px;
}
#canvas2{
  width: 90%;
  aspect-ratio: 1.165695583960448;
}
#canvas3{
  display: none;
}
body {
  width: 100vw;
  height: 82vh;
  display: flex;
  flex-direction: row;
  overflow: hidden;
}
.modulo{
 width: 100%;
}
.F1{
  display: flex;
  column-gap: 10px;
}
aside.Blk-1 {
  width: 20%;
  background-color: var(--az-cl-tr08);
  border: solid 0.5px var(--az-cl-tr08);
}
.textIzq{
  font-size: 100%;
  padding-top: 20px;
}
aside.Blk-2 {
  width: 80%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: var(--gr-fo-for);
  overflow-y: auto;
  overflow-x: hidden;
  padding-bottom: 1.5%;
}
.searchHeader{
  width: 100%;
  display: flex;
  /* justify-content: space-between; */
  color: var(--az-ico)
}
#colOcat, #simpOavan{
  height: 32px;
  display:flex;
  align-items: center;
  /* padding: 0.7%  5px  0.4% 10px; */
  /* line-height: 100%; */
  /* text-justify: center; */
  border: none;
  /* border-radius: 3px; */
  background-color: var(--gr-fo-cam);
}
.labRad{
  font-weight: 700;
  font-size: 110%;
  line-height: 102%;
  padding-left: 10px;
  padding-right: 15px;
}
input[type="radio"].rad1 {
  margin-left: 15px;
}
#simpOavan{
  margin-left: 10px;
}
.labRadCat{
  line-height: 102%;
  padding-left: 10px;
  padding-right: 15px;
}
fieldset p{ /* Es solo para la palabra BÚSQUEDA */
  padding-right: 15px;
  padding-left: 10px;
  font-weight: 700;
  font-size: 80%;
}
.Blk-botonesTelCat{
  display: none;
}
article.Form {
  /* color: darkslategray; */
  width: 95%;
  padding-top: 20px;
  margin-top: 10px;
}
.justiTel{
  display: flex;
  flex-direction: row;
}
.coinciTel{
  display: none;
}
.coleccionesSel{
  color: black;
  width: 100%;
  font-size: 1.1vw;
  display: flex;
  flex-direction: row;
  justify-content:space-between;
  gap: 4px;
}
.colSel{
  color: white;
  background-color: rgb(20, 102, 139);
  border: none;
  padding: 4px 8px;
  /* flex-basis: 100%; */
}
.colNoSel{
  color:black;
  background-color: rgb(196, 196, 196);
  border: none;
  padding: 4px 8px;
  /* flex-basis: 100%; */
}
.colSel:nth-child(1) { flex-grow: 0.25;}
.colSel:nth-child(4) { flex-grow: 0.15;}
.colSel:nth-child(7) { flex-grow: 0.25;}
.colSel:nth-child(8) { flex-grow: 0.25;}
.colNoSel:nth-child(1) { flex-grow: 0.25;}
.colNoSel:nth-child(4) { flex-grow: 0.15;}
.colNoSel:nth-child(7) { flex-grow: 0.25;}
.colNoSel:nth-child(8) { flex-grow: 0.25;}
.colNoSel:hover, .colSel:hover{
  cursor: pointer;
}
.buscaPalCol{
  height: 22px;
  width: 60%;
  margin-top: 5px;
  padding-left: 10px;
}
#cat{
  margin-left: 10px;
}
.busq{
  display: flex;
}
.colecciones{
  width: 100%;
  /* height: 40px; */
  /* border: solid 1px white; */
  margin-top: 10px;
  border-radius: 3px;
}
.catastro{
  width: 100%;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: solid 1px white;
  margin-top: 10px;
  border-radius: 3px;
}
.buscaPalCat{
  width: 80%;
  height: 46.7%;
  border: none;
}
.BtnBuscarCat, .BtnBuscarCol{
  height: 46.7%;
  width: 10%;
  background-color: rgb(30, 119, 161);
  color: white;
  font-weight: 700;
  border: none;
  border-radius: 3px;
  margin-left: 3px;
  align-self: center;
}
.BtnBuscarCat:hover, .BtnBuscarCol:hover {
  cursor: pointer;
  background-color: rgb(20, 102, 139);
}
.BtnBuscarCat:disabled, .BtnBuscarCol:disabled {
  cursor:default;
  background-color: rgb(176, 177, 177);
}
.BtnBuscarCol{
  height: 25px;
}

.BtnYPul{
  background-color: rgb(255, 145, 0);
}
.resultCat{
  width: 100%;
  border-radius: 3px;
  background-color: rgb(245, 244, 244);
  margin-top: 15px;
  /* padding: 20px; */
  color: var(--az-ico);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.Blk-Res{
  border-bottom: solid 1px gray;
  padding: 10px 10px;
  width: 97.5%;
}
.titular{
  text-align: left;
  font-weight: 700;
  color: rgb(30, 119, 161);
}
.L1{
  text-align: left;
  font-size: 80%;
  font-weight: 700;
  color : black;
}
.L12{
  text-align: left;
  font-size: 75%;
  font-weight: 700;
  color : black;
}
.L2{
  font-size: 14px;
  text-align: left;
  color : black;
  font-size: 80%;
  width: 95%;
}
.L3{
  text-align: left;
  font-size: 80%;
  font-weight: 700;
  color: rgb(105, 105, 105);
  margin: 3px 0;
}
.busqAv1{
  display: flex;
  width: 100%;
  gap: 3px;
  margin-top:5px;
}
.bAvIt{
 border: solid 1px rgb(105, 105, 105);
 border-radius: 3px;
 width: 33.3%;
 display: flex;
 flex-direction: column;
}
.colOcat{
  color: var(--az-cl-tr08);
  display: flex;
  margin-left: 10px;
}
.loader {
  border: 4px solid transparent;
  border-top-color: #3498db;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 2s linear infinite;
  margin: auto;
  margin-top: 30px;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@media screen and (max-width: 600px){
  *{
    margin: 0;
    padding: 0;
  }
  body {
    /* height: auto; */
    display: flex;
    flex-direction: column;
    /* justify-content: flex-start; */
  }
  .Blk-1{
    display: none;
  }
  aside.Blk-2 {
    width: 100%;
    height: 84vh;
    padding-top: 5px;
  }
  .catastro{
    width: 99.5%;
    height: 35px;
    border: none;
  }
  .buscaPalCat{
    width: 100%;
    height: 70%;
  }
  article.Form {
    width: 92%;
    align-self: center;
    padding-top: 5px;
    margin-top: 5px;
  }
  .Form {
    padding-top: 3px;
    overflow: scroll;
  }
  .searchHeader{
    display: flex;
    flex-direction: column;
    width: 80%;
  }
  #colOcat, #simpOavan{
    height: 28px;
    /* height: 95%; */
    /* margin: 0px; */
    /* padding: 0px; */
    /* border: none; */
  }
  #colOcat{
    /* padding: 0px; */
    /* display: flex; */
    /* flex-direction: row; */
    /* align-items: center; */
    /* gap: 5px; */

    /* font-weight: 700; */
    /* line-height: 90%; */
    /* text-align: left; */
    /* padding-left: 3%; */
    /* margin-bottom: 2px; */
  }
  .labRad{
    /* padding-left: 2%; */
    /* padding-top: 1.6%; */
    /* font-size: 90%; */
  }
  #simpOavan{
    margin-left: 0px;
    margin-top: 3px;
  }
  fieldset p{ /* es solo para la palabra BÚSQUEDA */
    padding-right: 15px;
    padding-top: 0%;
    padding-left: 3%;
    font-weight: 700;
    font-size: 78%;
  }
  .colecciones{
    width: 100%;
  }
  .coleccionesSel{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .colSel, .colNoSel{
    height: 25px;
    flex-basis: calc(33% - 2px);
    font-size: 230%;
    padding: 4px 4px;
  }
  .Blk-botonesTelCat{
    display: flex;
    flex-direction: column;
    width: 19%;
    margin-left: 3px;
  }
  .coinciTel{
    display: block;
    width: 99%;
    color: white;
    background-color:rgb(30, 119, 161);
    margin-top: 6px;
    font-weight: 400;
    font-size: 84%;
    padding-bottom: 2px;
  }
  .myCanvas {
    margin: 10px auto;
  }
  #canvas3{
    display: block;
    width: 78%;
    aspect-ratio: 1.165695583960448;
  }
  .Btn-BusCat-Tel{
    background-color: rgb(30, 119, 161);
    color: white;
    font-weight: 600;
    border: none;
    border-radius: 0px;
    height: 28px;
    margin-bottom: 3px;
    padding-bottom: 2px;
  }
  .Btn-Map-Tel{
    background-color: rgb(62, 179, 233);
    color: white;
    font-weight: 600;
    border: none;
    border-radius: 0px;
    height: 28px;
    margin-bottom: 0px;
    padding-bottom: 2.5px;
  }
  .busq{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .modulo{
    width: 90%;
  }
  .buscaPalCol{
    height: 22px;
    width: 97%;
    margin-top: 10px;
    border: none;
  }
  .BtnBuscarCat, .BtnBuscarCol{
    display: none;
  }
  .F1{
    width: 99%;
    display: flex;
    column-gap: 3px;
  }
  .Blk-Res{
    border-bottom: solid 1px gray;
    padding: 10px 10px;
    width: 94%;
  }
  .titular{
    font-size:14px;
  }
}
@media screen and (max-width: 500px){
  /* #simpOavan{
    margin-left: 15px;
  } */
  .labRad{
    padding-top: 4px;
    padding-left: 7px;
}
  .labRadCat{
    padding-top: 4px;
    padding-left: 5px;
    padding-right: 10px;
  }
  fieldset p{ /* Es solo para la palabra BÚSQUEDA */
    padding-top: 5px;
  }
  input[type="radio"].rad1 {
    margin-top: 6px;
  }
  input[type="radio"].rad2 {
    margin-top: 6px;
  }
}
</style>
